module.exports = __webpack_public_path__ + "img/nav_3.04276fd0.gif";